export default {
	setErrorMessage({ state, commit, dispatch }, error) {
		let message = ''
		if (typeof error === 'object' && error.message) {
			if (error.withoutRetry) message = error.message
			else message = 'Please try again! '+error.message
		}
		else message = 'It seems your Internet connection is unstable. Please try again.'
		commit('setSnackbarNotification', message)
	}
}
